(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/generate-boards.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/generate-boards.js');

'use strict';

const _excluded = ["boards", "count"],
  _excluded2 = ["count"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  gameWager,
  productMapping,
  rules: {
    getRules,
    system: systemRules
  }
} = svs.numbergames;
function isInRange(value, range) {
  const {
    min = 0,
    max = 0
  } = range !== null && range !== void 0 ? range : {};
  return Number.isInteger(value) && value >= min && value <= max;
}
function verifyNumberArray(numbers, maxLength, maxValue) {
  if (!Array.isArray(numbers)) return [];
  const verifiedNumbers = [];
  const numbersSet = new Set();
  numbers.forEach(n => {
    const number = Number(n.number || n);
    const manual = Boolean(n.manual);
    if (isInRange(number, {
      min: 1,
      max: maxValue
    }) && !numbersSet.has(number)) {
      numbersSet.add(number);
      verifiedNumbers.push({
        number,
        manual
      });
    }
  });
  if (verifiedNumbers.length > maxLength) return [];
  return verifiedNumbers;
}

function getBoardOptionsHandler(rules) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const getIsSystemBoard = () => Boolean(options === null || options === void 0 ? void 0 : options.isSystemBoard);
  const getLevel = () => {
    var _rules$SYSTEM;
    const levels = getIsSystemBoard() ? (_rules$SYSTEM = rules.SYSTEM) === null || _rules$SYSTEM === void 0 ? void 0 : _rules$SYSTEM.levels : rules.levels;
    return isInRange(options.level, levels) ? options.level : levels === null || levels === void 0 ? void 0 : levels.preset;
  };
  const getHasKungKeno = () => {
    var _options$hasKungKeno;
    return rules.kungKeno && ((_options$hasKungKeno = options.hasKungKeno) !== null && _options$hasKungKeno !== void 0 ? _options$hasKungKeno : rules.kungKeno);
  };
  const getRowPrice = () => rules.rowPrice;
  const getRowPriceMulti = () => {
    var _rules$rowPriceMultip, _rules$rowPriceMultip2;
    return rules !== null && rules !== void 0 && (_rules$rowPriceMultip = rules.rowPriceMultipliers) !== null && _rules$rowPriceMultip !== void 0 && (_rules$rowPriceMultip2 = _rules$rowPriceMultip.includes) !== null && _rules$rowPriceMultip2 !== void 0 && _rules$rowPriceMultip2.call(_rules$rowPriceMultip, options.rowPriceMulti) ? options.rowPriceMulti : 1;
  };
  const getSystemSize = () => {
    var _options$systemSize;
    if (!getIsSystemBoard()) return;
    const {
      numbersSize = 0,
      extraNumbersSize = 0
    } = (_options$systemSize = options.systemSize) !== null && _options$systemSize !== void 0 ? _options$systemSize : {};
    const {
      numbersLimits,
      numbersExtraLimits
    } = systemRules.systemLimits({
      rules,
      numberSize: numbersSize,
      numberExtraSize: extraNumbersSize,
      level: getLevel()
    });
    const isValidSystemSize = isInRange(numbersSize, numbersLimits) && isInRange(extraNumbersSize, numbersExtraLimits);
    return {
      numbersSize: isValidSystemSize ? numbersSize : 0,
      extraNumbersSize: isValidSystemSize ? extraNumbersSize : 0
    };
  };
  const getRow = () => {
    var _ref, _systemSize$numbersSi, _systemSize$extraNumb;
    const systemSize = getSystemSize();
    const numbersLength = (_ref = (_systemSize$numbersSi = systemSize === null || systemSize === void 0 ? void 0 : systemSize.numbersSize) !== null && _systemSize$numbersSi !== void 0 ? _systemSize$numbersSi : getLevel()) !== null && _ref !== void 0 ? _ref : rules.numbersMaxLength;
    const extraNumbersLength = (_systemSize$extraNumb = systemSize === null || systemSize === void 0 ? void 0 : systemSize.extraNumbersSize) !== null && _systemSize$extraNumb !== void 0 ? _systemSize$extraNumb : rules.numbersExtraMaxLength;
    return {
      numbers: verifyNumberArray(options.numbers, numbersLength, rules.numbersMaxValue),
      extraNumbers: verifyNumberArray(options.extraNumbers, extraNumbersLength, rules.numbersExtraMaxValue)
    };
  };
  return {
    getLevel,
    getHasKungKeno,
    getRowPrice,
    getRowPriceMulti,
    getIsSystemBoard,
    getSystemSize,
    getRow
  };
}

function generateBoard(product) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const rules = getRules(product);
  if (!rules) {
    gameWager.logger.warn("Can not generate board. Could not find rules for ".concat(product));
    return;
  }
  const boardOptionsHandler = gameWager.getBoardOptionsHandler(rules, options);
  const {
    numbers,
    extraNumbers
  } = boardOptionsHandler.getRow();
  const board = {
    productId: productMapping.getProductId(product),
    numbers,
    extraNumbers,
    level: boardOptionsHandler.getLevel(),
    hasKungKeno: boardOptionsHandler.getHasKungKeno(),
    rowPrice: boardOptionsHandler.getRowPrice(),
    rowPriceMulti: boardOptionsHandler.getRowPriceMulti(),
    isSystemBoard: boardOptionsHandler.getIsSystemBoard(),
    systemSize: boardOptionsHandler.getSystemSize()
  };
  if (options !== null && options !== void 0 && options.randomize) {
    ({
      numbers: board.numbers,
      extraNumbers: board.extraNumbers
    } = gameWager.randomizeRow(board));
  }
  return board;
}

function generateBoards(product, options) {
  const verifyCount = count => Number.isInteger(count) && count > 0 ? count : null;
  const _ref2 = options !== null && options !== void 0 ? options : {},
    {
      boards = [{}],
      count
    } = _ref2,
    opts = _objectWithoutProperties(_ref2, _excluded);
  return boards.reduce((arr, board) => {
    const {
        count: boardCount
      } = board,
      boardOpts = _objectWithoutProperties(board, _excluded2);
    let numberOfBoards = verifyCount(boardCount) || verifyCount(count) || 1;
    while (numberOfBoards--) {
      arr.push(gameWager.generateBoard(product, _objectSpread(_objectSpread({}, opts), boardOpts)));
    }
    return arr;
  }, []).filter(Boolean);
}
Object.assign(svs.numbergames.gameWager, {
  getBoardOptionsHandler,
  generateBoard,
  generateBoards
});

 })(window);